module.exports = __webpack_public_path__ + "img/service-swiper-3-pic.cb526fa0.png";